import css from 'styled-jsx/css';

const styles = css`@import "./styles/global-variables";
.fiftyfive-campaign{
    width:600px;
    margin:0 auto;
    max-width: 600px;
    @media (max-width: $breakpoint-max){
        width:100%;
        max-width: 600px;
        overflow: hidden;
    }
    }

    .fiftyfiveplus{
        margin: 0 10px;
        width: auto;
    }`;

export default styles;